import Photo from './Photo';
import { isDefaultImage } from '@lib/photo';

/** Iniciales para un negocio sin logo: «Que Lindas Nails» → «QL». */
const initials = (name = '') =>
  String(name)
    .replace(/[^\p{L}\p{N}\s]/gu, ' ')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join('') || 'Á';

/**
 * El anillo de Ágora (azul y coral, los colores del logo): marca a los negocios que toman turnos por
 * Ágora. Adentro, el logo del negocio o sus iniciales. `fit="contain"` para logos grandes que no se
 * pueden recortar (la tarjeta sin fotos).
 */
export default function Ring({ src, name, size = 40, className = '', fit = 'cover' }) {
  const hasImage = src && !isDefaultImage(src);
  return (
    <span
      className={`ring ${fit === 'contain' ? 'ring--contain' : ''} ${className}`}
      style={{ '--ring-size': `${size}px` }}
    >
      {hasImage ? (
        <Photo src={src} size={250} alt={name ? `Logo de ${name}` : ''} className="ring__img" />
      ) : (
        <span className="ring__img ring__mono" aria-hidden="true">
          {initials(name)}
        </span>
      )}
    </span>
  );
}
